import { motion } from 'framer-motion';
import { Headset, BarChart, LineChart, Link2 } from 'lucide-react';

const pillars = [
  {
    icon: Headset,
    title: 'CRM & Collections',
    description: 'Manage RPCs, AODs, arrangements, and recoveries with intelligent workflows.',
  },
  {
    icon: BarChart,
    title: 'Valuation Engine',
    description: 'Upload and price portfolios in minutes with predictive yield modelling.',
  },
  {
    icon: LineChart,
    title: 'Analytics Suite',
    description: 'Track performance, calibrate curves, and benchmark portfolio health.',
  },
  {
    icon: Link2,
    title: 'Exchange',
    description: 'Connect verified buyers and sellers for compliant, data-driven transactions.',
    badge: 'Optional',
  },
];

export function ProductGrid() {
  return (
    <section className="py-16 bg-card/50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-4">Complete Platform</h2>
          <p className="text-xl text-muted-foreground">
            Everything you need to run your debt business professionally
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((pillar, index) => {
            const Icon = pillar.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="relative p-6 rounded-lg border border-border bg-card hover:border-primary/50 hover:shadow-lg transition-all"
              >
                {pillar.badge && (
                  <span className="absolute top-4 right-4 text-xs px-2 py-1 rounded-full bg-accent/10 text-accent border border-accent/20">
                    {pillar.badge}
                  </span>
                )}
                <div className="mb-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 border border-primary/20">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold mb-2">{pillar.title}</h3>
                <p className="text-sm text-muted-foreground">{pillar.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
